import { Button, Css, ModalBody, ModalFooter, ModalHeader, SelectField, useModal } from "@homebound/beam";
import { useCallback, useState } from "react";
import { NamedFragment } from "src/fragments/commonFragments.generated";

type SelectTradePartnerModalProps = { tradePartners: NamedFragment[]; onSelect: (tradePartnerId: string) => void };

export function SelectTradePartnerModal(props: SelectTradePartnerModalProps) {
  const { tradePartners } = props;
  const { closeModal } = useModal();
  const [selectedTradePartnerId, setSelectedTradePartnerId] = useState<string | undefined>(tradePartners[0].id);

  const onSelect = useCallback(
    (tradePartnerId: string) => {
      props.onSelect(tradePartnerId);
      closeModal();
    },
    [props, closeModal],
  );
  return (
    <>
      <ModalHeader>Select Trade</ModalHeader>
      <ModalBody>
        <div css={Css.df.fdc.gap3.$}>
          <span>Pick a trade partner to enter a bid for:</span>
          <SelectField
            value={selectedTradePartnerId}
            label="Trade Partner"
            options={tradePartners}
            onSelect={setSelectedTradePartnerId}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={closeModal} label="Cancel" variant="quaternary" />
        <Button onClick={() => onSelect(selectedTradePartnerId!)} label="Continue" disabled={!selectedTradePartnerId} />
      </ModalFooter>
    </>
  );
}
